import React from "react";
import Topbar from "@/components/landing/Topbar";
import Hero from "@/components/landing/Hero";
import Platforms from "@/components/landing/Platforms";
import Services from "@/components/landing/Services";
import Worldwide from "@/components/landing/Worldwide";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  return (
    <div
      className="min-h-screen bg-[#F2EBDC] text-[#0A0A0A]"
      data-testid="landing-page"
    >
      <Topbar />
      <main>
        <Hero />
        <Platforms />
        <Services />
        <Worldwide />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
